function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#a166ff;}.cls-2{fill:#232f3e;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Amazon-Kinesis-Data-Streams_dark-bg");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Working"
}, React.createElement("rect", {
  id: "Purple_Dark_BG",
  "data-name": "Purple Dark BG",
  className: "cls-1",
  width: 75,
  height: 75
}), React.createElement("g", {
  id: "Product_Icon",
  "data-name": "Product Icon"
}, React.createElement("path", {
  className: "cls-2",
  d: "M62.5,32.51v2H53.68a83,83,0,0,1-8.77-.45h0c-18.74-2-32.4-10.18-32.4-20.29a8.88,8.88,0,0,1,.08-1.26h2a7.64,7.64,0,0,0-.1,1.26c0,10.34,17.59,18.75,39.22,18.75Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M62.5,36.51v2H60.38a15.65,15.65,0,0,0-2.19-2H62.5Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M40.25,36.19c-.32.22-.6.44-.9.68A15.53,15.53,0,0,0,38.07,38c-.32.32-.63.66-.92,1C24.49,40.13,15.63,42.93,12.5,47V44.1c4.37-3.71,12.45-5.63,20.38-6.61-7.93-1-16-2.92-20.38-6.63V28C15.88,32.35,25.94,35.27,40.25,36.19Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M62.5,36.52v2H60.38a15.65,15.65,0,0,0-2.19-2Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M62.5,28.51v2H58.36c-20,0-34.59-6.79-34.59-16.14,0,0,0-1.15,0-1.83h2c0,.48,0,1.47,0,1.83,0,8,14,14.19,32.59,14.19Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M34.81,42.77a13.79,13.79,0,0,0-.8,2.29c-11.68,3.25-19.55,9.3-19.55,16.21a8.38,8.38,0,0,0,.09,1.23h-2a8.38,8.38,0,0,1-.08-1.23C12.5,53.09,21.46,46.15,34.81,42.77Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M25.77,60.57c0,.39,0,1.52,0,1.93h-2c0-.66,0-1.91,0-1.93,0-4.64,3.62-8.65,9.73-11.5a14.79,14.79,0,0,0,.16,2.12C28.7,53.64,25.77,56.9,25.77,60.57Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M49,35.5A13.5,13.5,0,1,0,62.5,49,13.52,13.52,0,0,0,49,35.5Zm11,17a10.9,10.9,0,0,1-1.48,3h-5v2h3.24a11.48,11.48,0,0,1-15.48,0H42.5v-2h-3a10.9,10.9,0,0,1-1.48-3H42.5v-2H37.6a11.3,11.3,0,0,1,0-3h5.9v-2H38.05a10.9,10.9,0,0,1,1.48-3h11v-2H41.26a11.48,11.48,0,0,1,15.48,0H53.5a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1V44.32a11.42,11.42,0,0,1,1,4.68,10.6,10.6,0,0,1-.1,1.5H53.5v2Zm-2.45-10v3h-3v-3Z"
}), React.createElement("rect", {
  className: "cls-2",
  x: 45.5,
  y: 45.5,
  width: 5,
  height: 2
}), React.createElement("path", {
  className: "cls-2",
  d: "M50.5,57.5h-5a1,1,0,0,1-1-1v-5a1,1,0,0,1,1-1h5a1,1,0,0,1,1,1v5A1,1,0,0,1,50.5,57.5Zm-4-2h3v-3h-3Z"
})));

var SvgAwsKinesisStreams = function SvgAwsKinesisStreams(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 75 75",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsKinesisStreams, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-Kinesis_Streams.aec940ef.svg";
export { ForwardRef as ReactComponent };